import treePermitAPI from "@/services/treePermitAPI";
import estoreAPI from '@/services/estoreServiceAPI.js';

const appError = {
  applicationError: {
    hasError: true,
    error: [
      "Application server has encountered an error, please try again later or call support"
    ]
  }
};

const healthCheckError = {
  serviceError: {
    hasError: true,
    error: [
      "This service is temporarily unavailable. Please try again shortly."
    ]
  }
};

export default {
  healthCheck: ({ dispatch }) => {
    dispatch("estoreHealthCheck");
  },
  estoreHealthCheck: ({ commit, dispatch }) => {
    commit('setLoading', true);
    commit('setErrors', null);
    try {
      estoreAPI.healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            dispatch("serviceHealthCheck");
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", healthCheckError);
          }
        });
    } catch (e) {
      commit("setErrors", appError);
    } finally {
      commit('setLoading', false);
    }
  },
  serviceHealthCheck: ({ commit, dispatch }) => {
    try {
      commit('setLoading', true);
      commit('setErrors', null);
      treePermitAPI
        .healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            dispatch('fetchConfiguration');
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", healthCheckError);
          }
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  async fetchConfiguration({ commit }) {
    commit('setLoading', true);
    commit('setErrors', null);
    try {
      await treePermitAPI.
        fetchConfiguration()
        .then(response => {
          if (response && response.status === 200) {
            commit('setConfiguration', response.data);
          }
        })
        .catch(error => {
          commit("setErrors", appError);
        });

    } catch (e) {
      commit('setErrors', appError);
    } finally {
      commit('setLoading', false);
    }
  },
  async fetchDevelopmentData({ commit }) {
    commit('setLoading', true);
    commit('setErrors', null);
    try {
      await treePermitAPI.
        fetchDevelopmentApplicationFileList()
        .then(response => {
          if (response && response.status === 200) {
            commit('setDevelopmentFileList', response.data);
          }
        })
        .catch(error => {
          commit("setErrors", appError);
        });

    } catch (e) {
      commit('setErrors', appError);
    } finally {
      commit('setLoading', false);
    }
  }
};
